import { render, staticRenderFns } from "./ModalPieStudentSpecialTable.vue?vue&type=template&id=176ce0b3"
import script from "./ModalPieStudentSpecialTable.vue?vue&type=script&lang=js"
export * from "./ModalPieStudentSpecialTable.vue?vue&type=script&lang=js"
import style0 from "./ModalPieStudentSpecialTable.vue?vue&type=style&index=0&id=176ce0b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports